"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageContent = void 0;
const getClient_1 = require("./utils/getClient");
const getContentfulEntries_1 = require("./utils/getContentfulEntries");
const transformObjectToRemoveFields_1 = require("./utils/transformObjectToRemoveFields");
/**
 * Get content for a page from contentful including all the metadata
 */
const getPageContent = async ({ space, accessToken, host, contentType, slug, locale, environment, trackingApplicationName }) => {
    const client = (0, getClient_1.getClient)({ space, accessToken, host, environment });
    const content = await (0, getContentfulEntries_1.getContentfulEntries)({
        client,
        contentType,
        slug,
        locale,
        space,
        trackingApplicationName
    });
    return (0, transformObjectToRemoveFields_1.transformObjectToRemoveFields)(content.items[0]);
};
exports.getPageContent = getPageContent;
//# sourceMappingURL=getPageContent.js.map